import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const PublishPlanAsTemplateModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-publishplanastemplatemodalcontainer" */ "./PublishPlanAsTemplateModalContainer")).then((bundle)=>{
        return {
            default: bundle.PublishPlanAsTemplateModalContainer
        };
    });
export const LazyPublishPlanAsTemplateModalContainer = /*#__PURE__*/ lazy(PublishPlanAsTemplateModalContainerLazyLoader);
